<template>
    <v-footer class="fontSize" absolute color="#1c3d50" dark>
        <div class="font-weight-regular"> ©2017- {{ new Date().getFullYear() }} Global Psytech Sdn. Bhd.</div>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
.fontSize{
  font-size: 13px;
}
</style>